module.exports = __webpack_public_path__ + "static/media/valid-till.79ea7bde.svg";